<div class="row button-container">
    <div class="col-2 custom-button">
        <div class="rSet enable-alo-label">
            <label aria-hidden="true">
                Enable feature
                <input type="checkbox" class="primary-checkbox" id="enable" [(ngModel)]="ngModelval['AloEnabledVal']"
                    name="enable" [checked]="isEnableFeature" (change)="rSetChanged($event.target.checked)" />
                <span id="ALO-enableFeature-checkbox" class="extra-border-enablefeat"></span>
            </label>
        </div>
    </div>
    <span class="col-1 aoc-tooltips" *ngIf="defaultColor===false">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div id="ALO-RestoreDefault-button" class="col-9 title-tooltip">Restore default</div>
            </div>
        </ng-template>
    </span>
    <span class="col-1 aoc-tooltips" *ngIf="defaultColor===true">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div id="ALO-Default-button" class="col-9 title-tooltip">Default</div>
            </div>
        </ng-template>
    </span>

    <div class="col-8"></div>
    <div class="col-1"></div>
</div>
<div id="ALO-slider-container" class="row slider-container" [ngClass]="{'isResetDisabled': aloDisbaled}">
    <div id="ALO-sliderName-text" class="col-1 label signifyBookmd dim-margin">ALO</div>
    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
                <span id="ALO-STDmin" class=" signifyBookmd minValue"> min {{aloPercentageMinimum}}</span>
            </div>
            <div class="col-3">
                <span id="ALO-STDmax" class="signifyBookmd maxValue"> max {{aloPercentageMaximum}}</span>
            </div>
        </div>
    </div>

    <span id="ALO-slider-min" *ngIf="!quickConfigvalue" class="signifyBookmd text-mindim  sliderMinValue col-1">{{aloPercentageMinimum}}</span>
    <div *ngIf="!quickConfigvalue" class="col-6 curvePadding sliderCss" id="sliderClick"
        [ngClass]="{'isSliderClick': aloDisbaled}">
        <ngx-slider type="normalType" [options]="aloPercentageOption" [(value)]="ngModelval['AloPercentageVal']"
            (userChangeEnd)="aloPercentageSliderChange($event.value)" ngDefaultControl>
        </ngx-slider>
    </div>
    <span id="ALO-slider-max" *ngIf="!quickConfigvalue"
        class="signifyBookmd text-mindim col-1" [ngClass]="{'maxValueCss': quickConfigvalue===true}">{{aloPercentageMaximum}}</span>


    <div class="row form-group col-3">
        <input id="ALO-Input" type="number" (keypress)="numberOnly($event)" [disabled]="aloDisbaled"
            [value]="aloPercentageDisplayValue" (input)="onFieldInput($event.target.value, 'aloPercentage')"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [ngClass]="{'myStyle': inputError['aloPercentage']===true,'isResetDisabled custom-inputbox-disabled': aloDisbaled}">
        <p id="ALO-Units" class="unit signifyBookmd">%</p>
    </div>
</div>
<div id="ALO-Min-slider-container" *ngIf="showAloMinSlider" class="row slider-container" [ngClass]="{'isResetDisabled': aloDisbaled}">
    <div id="ALO-Min-sliderName-text" class="col-1 label signifyBookmd dim-margin">ALO min</div>
    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
                <span id="ALO-Min-STDmin" class=" signifyBookmd minValue"> min {{aloMinLevelMinimum}}</span>
            </div>
            <div class="col-3">
                <span id="ALO-Min-STDmax" class="signifyBookmd maxValue"> max {{aloMinLevelMaximum}}</span>
            </div>
        </div>
    </div>
    <span id="ALO-Min-slider-min" *ngIf="!quickConfigvalue" class="signifyBookmd text-mindim  sliderMinValue col-1">{{aloMinLevelMinimum}}</span>
    <div class="col-6 curvePadding sliderCss" *ngIf="!quickConfigvalue" [id]="'sliderClick'"
        [ngClass]="{'isSliderClick': aloDisbaled}">
        <ngx-slider type="normalType" [options]=aloMinLevelOption [(value)]="ngModelval['AloMinLevelVal']"
            (userChangeEnd)="aloMinValueChange($event.value)" ngDefaultControl>
        </ngx-slider>
    </div>
    <span id="ALO-Min-slider-max" *ngIf="!quickConfigvalue" class="signifyBookmd text-mindim col-1" [ngClass]="{'maxValueCss': quickConfigvalue===true}">{{aloMinLevelMaximum}}</span>
    <div class="row form-group col-3">
        <input id="ALO-Min-Input" type="number" (keypress)="numberOnly($event)" [value]="aloMinLevelDisplayValue"
            (input)="onFieldInput($event.target.value, 'aloMinLevel')"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" [disabled]="aloDisbaled"
            [ngClass]="{'myStyle': inputError['aloMinLevel']===true,'isResetDisabled custom-inputbox-disabled': aloDisbaled}" />
        <p id="ALO-Min-Units" class="unit signifyBookmd">%</p>
    </div>
</div>
<br>
